export default __webpack_public_path__ + "static/media/product-raise-funds.5f6c8e04.png";